import { useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import OlImageLayer from 'ol/layer/Image'
import ImageStaticSource from 'ol/source/ImageStatic'

export default function ImageLayer({ map, imageUrl, projection, extent }) {
  const layer = useMemo(
    () =>
      new OlImageLayer({
        source: new ImageStaticSource({
          url: imageUrl,
          projection: projection,
          imageExtent: extent,
          crossOrigin: 'anonymous',
        }),
      }),
    [imageUrl, projection, extent]
  )

  useEffect(() => {
    map.addLayer(layer)
    return () => {
      map.removeLayer(layer)
    }
  }, [map, layer])

  return null
}

ImageLayer.propTypes = {
  map: PropTypes.shape({
    addLayer: PropTypes.func,
    removeLayer: PropTypes.func,
  }).isRequired,
  imageUrl: PropTypes.string.isRequired,
  projection: PropTypes.object.isRequired,
  extent: PropTypes.array.isRequired,
}
